import { render, staticRenderFns } from "./Merchandising.vue?vue&type=template&id=1cdf4fa2&scoped=true&"
import script from "./Merchandising.vue?vue&type=script&lang=js&"
export * from "./Merchandising.vue?vue&type=script&lang=js&"
import style0 from "./Merchandising.vue?vue&type=style&index=0&id=1cdf4fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdf4fa2",
  null
  
)

export default component.exports